import { useForm } from 'react-hook-form';
import { getHappycallQuestionList, saveHappycallResult } from '../store/api/HappycallAPI';
import HappycallItem from "../../Services/Components/Happycall/HappycallItem";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Loader from "react-loader-spinner";
import QRCodeReader from "../../Services/Components/QRCode_Reader/QR_Reader";
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faQrcode } from '@fortawesome/free-solid-svg-icons';
const Happycall = () => {
    const dispatch = useDispatch();
    const { serviceType, serviceID } = useParams();
    const [questionList, setQuestionList] = useState([]);
    const { popQrReader, setPopQrReader } = useState({ show: false });
    const { selectedProduct, selectProduct } = useState(null);
    const { register, handleSubmit, errors } = useForm();
    useEffect(() => {
        document.body.className = "notMain";
        const activeInInstall = serviceType?.toLowerCase() === "install";
        const activeInRepair = serviceType?.toLowerCase() === "repair";
        getHappycallQuestionList(0, activeInInstall, activeInRepair, setQuestionList);
    }, []);
    useEffect(() => {

    }, []);
    const history = useHistory();
    function onSubmit(data) {
        let results = [];
        Object.keys(data).forEach(key => key !== "ProductId" && key !== "ServiceType" ? results.push({ ID: key, Value: data[key] }) : "");
        let dataToSend = {
            ProductId: data.ProductId,
            ServiceType: data.ServiceType,
            ServiceID: serviceID,
            Results: results
        }
        dispatch(saveHappycallResult(dataToSend, () => {

            history.push("/Services");

        }));
    }
    function showQrReader() {
        setPopQrReader({
            show: true,
            onScan: selectProduct
        })
    }

    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle" >
                    <FontAwesomeIcon icon={faHeadset} size='lg' /> &nbsp;
                    رضایت سنجی
                </Card.Header>
                <Card.Body className="bodyStyle">
                    {questionList === "PENDING" && <Loader type="BallTriangle" color="#bb1370" height={50} width={50} />}
                    {/* <Button variant='light' onClick={showQrReader} style={{ padding: 0 }}><FontAwesomeIcon icon={faQrcode} size='lg' /></Button> */}
                    {/* <QRCodeReader popData={popQrReader} setPopData={setPopQrReader} /> */}
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col md={3} className="form-group">
                                <label> نام محصول </label>
                                <input type="hidden" name="ProductId" ref={register()} value={selectedProduct?.ID ?? ""} />
                                <Form.Control value={selectedProduct?.Name ?? ""} readOnly />
                            </Col>
                            <Col md={3} className="form-group">
                                <label> مدل محصول </label>
                                <Form.Control value={selectedProduct?.Model ?? ""} readOnly />
                            </Col>
                            <Col md={3} className="form-group">
                                <label> شماره سریال </label>
                                <Form.Control name="SerialNumber" style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} value={selectedProduct?.SerialNumber ?? ""} onChange={e => selectProduct({ ...selectedProduct, SerialNumber: e.target.value })} />
                            </Col>

                            <Col md={3} className="form-group">
                                <label> نوع سرویس </label>
                                <select className="form-control" name="ServiceType" ref={register({ required: true })} defaultValue={serviceType}>
                                    <option value=""> لطفا انتخاب کنید </option>
                                    <option value="repair"> تعمیر </option>
                                    <option value="install"> نصب </option>
                                </select>
                                {errors.ServiceType && <small className="errors"> نوع را وارد کنید </small>}
                            </Col>
                        </Row>
                        <Row>
                            {questionList === "PENDING" &&
                                <Loader color="#bb1370" type="BallTriangle" width={25} height={25} />
                            }
                            {questionList && Array.isArray(questionList) && questionList.map((item, i) => <HappycallItem item={item} register={register} key={i} />)}
                        </Row>
                        <Button variant='success' type='submit' className="w-100 mt-2">ثبت دیدگاه</Button>

                    </form>
                </Card.Body>
            </Card>
        </div >
    )

}
export default Happycall;